import { apiClient } from './apiClient';
import type { TermsStatus } from '../types/terms';

// SW-91: the digital partner onboarding consent gate.
export const termsService = {
  async getStatus(token: string): Promise<TermsStatus> {
    return apiClient.get<TermsStatus>('/business-profile/terms-status', token);
  },

  async acceptTerms(token: string): Promise<TermsStatus> {
    return apiClient.post<TermsStatus>('/business-profile/terms-accept', undefined, token);
  },
};
